import React from 'react';
import { View, StyleSheet } from 'react-native';

import Theme from '../../theme';

const InviteIndication = () => (
    <View style={styles.circle} />
)

const styles = StyleSheet.create({
    circle: {
        width: 8,
        height: 8,
        marginRight: 5,
        borderRadius: 8 / 2,
        backgroundColor: Theme.PRIMARY,
    },
});

export default InviteIndication;
